<div class="flex justify-center items-center">
  <div class="flex flex-col">
    @if (showUsername) {
      <div>
        <pin-request-verification-code (forgotPasswordEventEmitter)="userInput($event)"></pin-request-verification-code>
      </div>
    } @else {
      <div>
        <pin-create-password [username]="username"></pin-create-password>
      </div>
    }
  </div>
</div>
